/**
 * Shared Types and Constants
 *
 * Code shared between server and client:
 * - API request/response types
 * - Common constants
 * - Utility types
 */

import type {BlobRef} from "@atproto/api";

// --- Library Entry Types ---

export interface LibraryEntry {
  type: "vocab" | "character";
  languageCode: string;
  content: Content;
  srsState: SRSState;
  grouping?: string;
  tags?: string[];
  createdAt: string;
  updatedAt?: string;
}

export interface Content {
  expression: string;
  meaning: string;
  readings?: Reading[];
  partsOfSpeech?: string[];
  auxiliary?: string;
  strokeImage?: BlobRef;
}

export interface Reading {
  type: "kana" | "romaji" | "on" | "kun" | "pinyin" | "ipa";
  value: string;
}

export interface SRSState {
  ease: number;
  intervalDays: number;
  dueAt: string;
  repetition: number;
}

// --- Study Session Types ---

export const STUDY_MODES = [
  "mixed",
  "character_flashcard",
  "character_drawing",
  "vocab_expression",
  "vocab_reading",
  "vocab_meaning",
] as const;

export type StudyMode = (typeof STUDY_MODES)[number];

export interface StudySession {
  startedAt: string;
  endedAt: string;
  activityType: "review_srs" | "cram" | "learn_new";
  sourceGroup?: string;
  items: StudyItem[];
}

export interface StudyItem {
  entryUri: string;
  score: number;
  timeSpentMs?: number;
}

// --- Constants ---

export const IDS = {
  LibraryEntry: "xyz.atarashii.library.entry",
  StudySession: "xyz.atarashii.study.session",
};
